import { render, staticRenderFns } from "./GenArtSearch.vue?vue&type=template&id=5b0f4138"
import script from "./GenArtSearch.vue?vue&type=script&lang=js"
export * from "./GenArtSearch.vue?vue&type=script&lang=js"
import style0 from "./GenArtSearch.vue?vue&type=style&index=0&id=5b0f4138&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports